import { Checkbox, TablePagination, TableCell } from '@mui/material';
import { useSelector } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';

import ThreeDotMenu from './ThreeDotMenu';
import {
  CustomTableCellForBody,
  CustomTableCellForNoData,
  CustomTableView,
} from '../../../../components/UI/CustomTableView';
import useUserTimeZone, { getTimeZoneAbbreviation } from '../../../../hooks/useUserTimeZone';
import useSortHook from '../../../../hooks/useSortHook';

const tableCellPStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '250px',
  maxHeight: '100px',
};

const TableViewInvite = ({
  data,
  paginationData,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDisplay,
  onDelete,
  onSelectedChange,
  selectedAccount,
  onChangeLog,
}) => {
  const { user } = useSelector((state) => state.login);
  const { handleSort, newSortData, sortState } = useSortHook(data, ['purchaseDate']);
  const { formatDate } = useUserTimeZone();
  const handleDoubleClick = (event, data) => {
    if (event.detail === 2) {
      onDisplay(data);
    }
  };

  const headData = [
    'Actions',
    'Event',
    'Only SafalSubscriptions Users',
    'Form Attached',
    'Invite Expiry',
    'Invited People',
  ];

  // const amountSym = user.country === 'United States' ? '$' : '₹';

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '48px' }}>
        {selectedAccount?.length > 0 ? (
          <div>
            <span>
              <b>{selectedAccount?.length}</b> selected
            </span>
          </div>
        ) : (
          <span />
        )}

        <TablePagination
          component="div"
          size="small"
          count={paginationData?.total ?? 0}
          rowsPerPageOptions={[10, 15, 25, 50, 100]}
          rowsPerPage={paginationData?.limit ?? 15}
          page={paginationData.page - 1}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </div>
      <TableContainer sx={{ maxHeight: 600 }}>
        <CustomTableView
          isSort
          sort={{
            order: sortState.order,
            orderBy: sortState.orderBy,
            createSortHandler: handleSort,
            sortHeadMap: ['', 'event.name', 'onlyRSVP', '', 'expiryDate', ''],
          }}
          headData={headData}
        >
          {data.length === 0 && (
            <CustomTableCellForNoData
              message={`There are no recorded event invite for you. Kindly add a create one.`}
            />
          )}
          {newSortData?.map((e, index) => {
            return (
              <TableRow key={index} onClick={(ev) => handleDoubleClick(ev, e)}>
                <CustomTableCellForBody align="center" padding="checkbox">
                  <div style={{ display: 'flex' }}>
                    {/* <Checkbox checked={selectedAccount.includes(e._id)} onChange={() => onSelectedChange(e._id)} /> */}
                    <ThreeDotMenu
                      // onChangeLog={() => onChangeLog(e)}
                      data={e}
                      onEdit={(flag) => {
                        if (flag) {
                          onDisplay(e);
                        } else {
                          onEdit(e);
                        }
                      }}
                      onDelete={() => onDelete(e)}
                    />
                  </div>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="center">
                  <p style={tableCellPStyle}>{e?.event?.name}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.onlyRSVP ? 'No' : 'Yes'}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.formData ? 'Yes' : 'No'}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.expiryDate ? `${formatDate(e?.expiryDate)}` : ''}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={{ ...tableCellPStyle, maxWidth: '100%' }}>
                    {e?.people?.map((e, index) => {
                      return (
                        <>
                          <span
                            style={{
                              fontSize: '13px',
                              whiteSpace: 'nowrap',
                              color: e?.status === 'Rejected' ? 'red' : e?.status === 'Accepted' ? 'green' : 'black',
                            }}
                          >
                            {e?.status} - {e?.email}
                          </span>
                          {index !== e?.people?.length - 1 && <br />}
                        </>
                      );
                    })}
                  </p>
                </CustomTableCellForBody>
              </TableRow>
            );
          })}
        </CustomTableView>
      </TableContainer>
    </>
  );
};

export default TableViewInvite;
